

import React from "react";
import TooltipLocal from '../components/TooltipLocal';
import TooltipPopover from '../components/TooltipPopover';


const Tooltip = () => {
    
    return (
      <div className="container mt-6">
          <div className="card">
              <div className="card-header">
                  <h3>Tooltip</h3>
              </div>
              <div className="card-body">
                  <div className="d-flex gap-2">
                    <TooltipLocal text="This is a tooltip!" position="top">
                      <button className="btn btn-primary">Top</button>
                    </TooltipLocal>
                    
                    <TooltipLocal text="Right tooltip" position="right">
                      <button className="btn btn-secondary">Right</button>
                    </TooltipLocal>
                    
                    <TooltipLocal text="Bottom tooltip" position="bottom">
                      <button className="btn btn-info">Bottom</button>
                    </TooltipLocal>
                    
                    <TooltipLocal text="Left tooltip" position="left">
                      <button className="btn btn-success">Left</button>
                    </TooltipLocal>
                  </div>
                  <div  className="d-flex gap-2 mt-3">
                      <TooltipPopover
                          type="tooltip"
                          title="Tooltip Title"
                          description="Here’s an implementation for tooltip and popover components that include both a title and a description. These components allow you to display a title as the header and a description as the body of the tooltip/popover."
                          position="top"
                        >
                          <button className="btn btn-primary">Hover</button>
                      </TooltipPopover>
                    
                      <TooltipPopover
                          type="popover"
                          title="Popover Title"
                          description="Here’s an implementation for tooltip and popover components that include both a title and a description. These components allow you to display a title as the header and a description as the body of the tooltip/popover."
                          position="top"
                        >
                          <button className="btn btn-secondary">Click</button>
                      </TooltipPopover>

                      <TooltipPopover
                          type="tooltip"
                          title="Tooltip Title"
                          description="Here’s an implementation for tooltip and popover components that include both a title and a description. These components allow you to display a title as the header and a description as the body of the tooltip/popover."
                          position="bottom"
                        >
                          <button className="btn btn-primary">Hover</button>
                      </TooltipPopover>
                  </div>
              </div>
          </div>
      </div>
    );
};

export default Tooltip;
